const colors = {
    white: '#FFFFFF',
    black: '#000000',
    gray1: '#f5f5f7',
    gray2: '#e8e8ed',
    gray3: '#d2d2d6',
    gray4: '#aeaeb2',
    gray5: '#8e8e93',
    accent: '#007aff',
    turquoise: '#3e9697',
    lightGray: '#e5e5ea',
    darkGray: '#8e8e93',
    blue: '#007aff',
    darkBlue: '#0051d5',
    red: '#ff3b30',
} as const;

export type ColorName = keyof typeof colors;
export type ThemeColor = typeof colors[ColorName];

export default colors;
